import React, { Component } from 'react';
import * as Firebase from 'firebase';
import 'firebase/auth';
import { getDatabase } from './firestore';
import Avatar from '@material-ui/core/Avatar';
//import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import TextLoop from 'react-text-loop';
//import Typography from '@material-ui/core/Typography';

//const apikey = "eb96440115b64cc1b73320697a02219b";
//iplocation = https://api.ipgeolocation.io/ipgeo?apiKey=API_KEY&ip=1.1.1.1

const rootRef = getDatabase()
  .ref()
  .child('BiljartWedstrijd');
let WedstrijdData1 = rootRef;
let WedstrijdData2 = rootRef;
let WedstrijdData3 = rootRef;
let WedstrijdData4 = rootRef;
//let WedstrijdData = "";

const styles = {
  card: {
    flex: 1,
    flexDirection: 'row',
    minWidth: 275,
    backgroundColor: '#E2FBFF'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  title: {
    marginBottom: 16,
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  root: {
    flexGrow: 1,
    flex: 1,
    paddingLeft: 2,
    paddingRight: 2
  },
  Mededeling: {
    width: '100%',
    fontSize: 20,
    //fontWeight: "bold",
    paddingLeft: 10,
    color: 'blue'
  },
  Smallekolom: {
    width: '15%',
    fontSize: 18,
    //fontWeight: "bold",
    paddingLeft: 10,
    color: 'blue'
  },
  SmallekolomGray: {
    width: '15%',
    fontSize: 12,
    //fontWeight: "bold",
    paddingLeft: 10,
    color: 'gray'
  },
  Spelernaam: {
    width: '100%',

    fontSize: 18,
    //fontWeight: "bold",
    paddingLeft: 10,
    paddingRight: 10,
    color: 'blue'
  },
  SpelernaamGray: {
    width: '70%',
    fontSize: 12,
    //fontWeight: "bold",
    paddingLeft: 10,
    color: 'gray'
  },
  ActiveSpeler: {
    backgroundColor: 'green'
  },
  NonActiveSpeler: {
    backgroundColor: 'white'
  },
  avatarBeurten: {
    //position: "relative",
    //postion: "float",
    // marginBottom: -80,
    // marginLeft: 0,
    width: 30,
    height: 30,
    fontSize: 18,
    backgroundColor: 'red',
    color: 'white'
  },
  avatarCaramboles: {
    //position: "relative",
    //postion: "float",
    // marginBottom: -80,
    // marginLeft: 0,
    width: 40,
    height: 40,
    fontSize: 28,
    backgroundColor: 'green',
    color: 'white'
  },
  avatarCarambolesGray: {
    width: 50,
    height: 50,
    fontSize: 28,
    backgroundColor: 'gray'
  },
  avatarSerie: {
    //position: "relative",
    //postion: "float",
    // marginBottom: -80,
    //paddingLeft: 50,
    width: 30,
    height: 30,
    fontSize: 12,
    backgroundColor: 'gold',
    color: 'black'
  },
  avatarSerieBlack: {
    //position: "relative",
    //postion: "float",
    // marginBottom: -80,
    //paddingLeft: 50,
    width: 30,
    height: 30,
    fontSize: 12,
    backgroundColor: 'black',
    color: 'white'
  },
  avatarSerieGold: {
    //position: "relative",
    //postion: "float",
    // marginBottom: -80,
    //paddingLeft: 50,
    width: 30,
    height: 30,
    fontSize: 12,
    backgroundColor: 'gold',
    color: 'black'
  },
  td: {
    width: 40,
    height: 40,
    alignSelf: 'center'
  },
  tdNaam: {
    width: 200,
    height: 40,
    alignSelf: 'center'
  },
  avatarSerieScore: {
    //position: "relative",
    //postion: "float",
    // marginBottom: -80,
    //paddingLeft: 50,
    padding: 10,
    width: 30,
    height: 30,
    fontSize: 14,
    backgroundColor: 'steelblue',
    color: 'white'
  },
  avatarSerieGray: {
    width: 30,
    height: 30,
    fontSize: 12,
    backgroundColor: 'gold',
    color: 'black'
  },
  avatarHuidigCaramboles: {
    width: 90,
    height: 90,
    fontSize: 68,
    backgroundColor: 'blue'
  },
  avatarHuidigCarambolesGray: {
    width: 90,
    height: 90,
    fontSize: 68,
    backgroundColor: 'gray'
  },
  appbarSpeler: {
    flex: 1,
    //flexDirection: "row",
    backgroundColor: 'steelblue',
    //alignItems: "stretch",
    justifyContent: 'space-between',
    borderRadius: 5,
    marginTop: -15
  },
  appbarSpelerGray: {
    flex: 1,
    //flexDirection: "row",
    backgroundColor: 'lightgray',
    //alignItems: "stretch",
    justifyContent: 'space-between',
    borderRadius: 5,
    marginTop: -15
  },
  appbarSpeler2: {
    flex: 1,
    //flexDirection: "row",
    backgroundColor: 'steelblue',
    //alignItems: "stretch",
    justifyContent: 'space-between',
    borderRadius: 5
    //marginTop: -15
  },
  appbarSpeler2Gray: {
    flex: 1,
    //flexDirection: "row",
    backgroundColor: 'lightgray',
    //alignItems: "stretch",
    justifyContent: 'space-between',
    borderRadius: 5
  },
  addCaramboles: {
    alignItems: 'right'
  }
};

class ScoreboardInvoertafels extends Component {
  constructor(props) {
    super(props);
    // console.log(this.props.match);
    this.state = {
      Wedstrijd1: [],
      Wedstrijd2: [],
      Wedstrijd3: [],
      Wedstrijd4: [],
      title: '',
      tafelNaam: this.props.tafel,
      vereniging: this.props.vereniging,
      ipadres: '0.0.0.0',
      editmode: false
    };
  }

  componentDidMount() {
    let title = '';
    if (this.props.tafel === '1-4') {
      title = '';
      if (window.location.href.split('//')[1].split('/')[0] === 'localhost:3000') {
        WedstrijdData1 = rootRef.child('Tafelthuis').child('Tafel1');
      } else {
        WedstrijdData1 = rootRef.child(this.state.vereniging).child('Tafel1');
      }

      WedstrijdData2 = rootRef.child(this.state.vereniging).child('Tafel2');
      WedstrijdData3 = rootRef.child(this.state.vereniging).child('Tafel3');
      WedstrijdData4 = rootRef.child(this.state.vereniging).child('Tafel4');
    }
    if (this.props.tafel === '5-8') {
      title = '';
      WedstrijdData1 = rootRef.child(this.state.vereniging).child('Tafel5');
      WedstrijdData2 = rootRef.child(this.state.vereniging).child('Tafel6');
      WedstrijdData3 = rootRef.child(this.state.vereniging).child('Tafel7');
      WedstrijdData4 = rootRef.child(this.state.vereniging).child('Tafel8');
    }
    WedstrijdData1.on('value', snap => {
      this.setState({
        Wedstrijd1: snap.val(),
        currentPage: 0,
        title
        //width: Dimensions.get("window").width
      });
    });
    WedstrijdData2.on('value', snap2 => {
      this.setState({
        Wedstrijd2: snap2.val(),
        currentPage: 0
        //width: Dimensions.get("window").width
      });
    });
    WedstrijdData3.on('value', snap3 => {
      this.setState({
        Wedstrijd3: snap3.val(),
        currentPage: 0
        //width: Dimensions.get("window").width
      });
    });
    WedstrijdData4.on('value', snap4 => {
      this.setState({
        Wedstrijd4: snap4.val(),
        currentPage: 0
        //width: Dimensions.get("window").width
      });
    });

    // const ipurl = "https://api.ipgeolocation.io/ipgeo?apiKey=" + apikey;
    // fetch(ipurl)
    //   .then(response => response.json())
    //   .then(data => this.setState({ ipadres: data.ip }))
    //   .then(
    //     niets =>
    //       this.state.ipadres === "80.127.228.55" ||
    //       this.state.ipadres === "77.166.147.183"
    //         ? this.setState({ editmode: true })
    //         : null
    //   );
  }

  componentWillUnmount() {
    WedstrijdData1.off();
    WedstrijdData2.off();
    WedstrijdData3.off();
    WedstrijdData4.off();
  }
  /**
   * @inheritDoc
   */

  render() {
    const convertReeks = reeks => {
      if (reeks) {
        if (reeks === '') {
          return 0;
        } else {
          return reeks.split(',').reduce((a, b) => parseInt(a) + parseInt(b), 0);
        }
      }
    };
    return (
      <div align="center">
        <div align="center" style={{ maxWidth: 600 }}>
          {/* Tafel 1 */}
          {/* <div>
            {' '}
            <Toolbar style={{ justifyContent: 'flex-start', backgroundColor: 'lightsteelblue', fontSize: 12 }}>
              Wedstrijd uit fase {this.state.Wedstrijd1.Fase || 'Vrije wedstrijd'}
            </Toolbar>
          </div> */}
          <div>
            {this.state.Wedstrijd1.Speler1 !== 'Wachten op' && (
              <div style={{ marginBottom: 20 }}>
                <AppBar position="static" color="default" style={{ backgroundColor: 'white' }}>
                  <Toolbar style={{ justifyContent: 'flex-start' }}>
                    <table
                      //style={{width: 430px; height: 100px; margin-left: auto; margin-right: auto;}}
                      border="0"
                      cellspacing="0"
                      cellpadding="0"
                    >
                      <tbody>
                        <tr>
                          <td>Sets</td>
                          <td>&nbsp;</td>
                          <td
                            style={{
                              paddingLeft: 10
                            }}
                          >
                            Naam
                          </td>
                          {this.state.Wedstrijd1.Speler1Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieGray}>1</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Set2Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>2</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Set3Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>3</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Set4Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>4</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Set5Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>5</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Scoreverloop && (
                            <td style={{ color: 'blue' }}>
                              <TextLoop interval={2000}>{['Live', this.props.tafel === '1-4' ? 'T1' : 'T5']}</TextLoop>{' '}
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td style={styles.td}>
                            {this.state.Wedstrijd1.AantalsetsSpeler1 !== 0 ? (
                              <Avatar style={styles.avatarSerieBlack}>{this.state.Wedstrijd1.AantalsetsSpeler1}</Avatar>
                            ) : null}
                          </td>
                          <td style={styles.td}>
                            <Avatar rounded activeOpacity={1.0}>
                              <img src={this.state.Wedstrijd1.Speler1URL} style={{ width: 40 }} />
                            </Avatar>
                          </td>
                          <td style={styles.tdNaam}>
                            <div style={styles.Spelernaam}>
                              {this.state.Wedstrijd1.Speler1} {this.state.Wedstrijd1.Speler1Achternaam}
                            </div>
                          </td>
                          {this.state.Wedstrijd1.Speler1Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler1Set1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Set2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler1Set2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Set3Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler1Set3Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Set4Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler1Set4Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Set5Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler1Set5Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieBlack}>
                                {convertReeks(this.state.Wedstrijd1.Speler1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td style={styles.td}>
                            {this.state.Wedstrijd1.AantalsetsSpeler2 !== 0 ? (
                              <Avatar style={styles.avatarSerie}>{this.state.Wedstrijd1.AantalsetsSpeler2}</Avatar>
                            ) : null}
                          </td>
                          <td style={styles.td}>
                            <Avatar rounded activeOpacity={1.0}>
                              <img src={this.state.Wedstrijd1.Speler2URL} style={{ width: 40 }} />
                            </Avatar>
                          </td>
                          <td style={styles.tdNaam}>
                            <div style={styles.Spelernaam}>
                              {this.state.Wedstrijd1.Speler2} {this.state.Wedstrijd1.Speler2Achternaam}
                            </div>
                          </td>
                          {this.state.Wedstrijd1.Speler2Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler2Set1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler2Set2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler2Set2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler2Set3Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler2Set3Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler2Set4Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler2Set4Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler2Set5Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd1.Speler2Set5Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd1.Speler2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieGold}>
                                {convertReeks(this.state.Wedstrijd1.Speler2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </Toolbar>
                </AppBar>
              </div>
            )}
          </div>
          <div>
            {this.state.Wedstrijd1.Speler1 === 'Wachten op' && (
              <AppBar position="static" color="default" style={{ backgroundColor: 'white' }}>
                <Toolbar style={{ justifyContent: 'center' }}>
                  <div style={{ color: 'blue', fontSize: 14 }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>{'Geen partij actief'}</span>
                  </div>
                </Toolbar>
              </AppBar>
            )}
          </div>

          <div>
            {this.state.Wedstrijd2.Speler1 !== 'Wachten op' && (
              <div style={{ marginBottom: 20 }}>
                <AppBar position="static" color="default" style={{ backgroundColor: 'white' }}>
                  <Toolbar style={{ justifyContent: 'flex-start' }}>
                    <table
                      //style={{width: 430px; height: 100px; margin-left: auto; margin-right: auto;}}
                      border="0"
                      cellspacing="0"
                      cellpadding="0"
                    >
                      <tbody>
                        {/* <tr>{this.state.Wedstrijd2.Spelsoort}</tr> */}
                        <tr>
                          <td>Sets</td>
                          <td>&nbsp;</td>
                          <td
                            style={{
                              paddingLeft: 10
                            }}
                          >
                            Naam
                          </td>
                          {this.state.Wedstrijd2.Speler1Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieGray}>1</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Set2Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>2</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Set3Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>3</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Set4Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>4</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Set5Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>5</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Scoreverloop && (
                            <td style={{ color: 'blue' }}>
                              <TextLoop interval={2000}>{['Live', this.props.tafel === '1-4' ? 'T2' : 'T6']}</TextLoop>{' '}
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td style={styles.td}>
                            {this.state.Wedstrijd2.AantalsetsSpeler1 !== 0 ? (
                              <Avatar style={styles.avatarSerieBlack}>{this.state.Wedstrijd2.AantalsetsSpeler1}</Avatar>
                            ) : null}
                          </td>
                          <td style={styles.td}>
                            <Avatar rounded activeOpacity={1.0}>
                              <img src={this.state.Wedstrijd2.Speler1URL} style={{ width: 40 }} />
                            </Avatar>
                          </td>
                          <td style={styles.tdNaam}>
                            <div style={styles.Spelernaam}>
                              {this.state.Wedstrijd2.Speler1} {this.state.Wedstrijd2.Speler1Achternaam}
                            </div>
                          </td>
                          {this.state.Wedstrijd2.Speler1Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler1Set1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Set2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler1Set2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Set3Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler1Set3Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Set4Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler1Set4Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Set5Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler1Set5Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieBlack}>
                                {convertReeks(this.state.Wedstrijd2.Speler1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td style={styles.td}>
                            {this.state.Wedstrijd2.AantalsetsSpeler2 !== 0 ? (
                              <Avatar style={styles.avatarSerie}>{this.state.Wedstrijd2.AantalsetsSpeler2}</Avatar>
                            ) : null}
                          </td>
                          <td style={styles.td}>
                            <Avatar rounded activeOpacity={1.0}>
                              <img src={this.state.Wedstrijd2.Speler2URL} style={{ width: 40 }} />
                            </Avatar>
                          </td>
                          <td style={styles.tdNaam}>
                            <div style={styles.Spelernaam}>
                              {this.state.Wedstrijd2.Speler2} {this.state.Wedstrijd2.Speler2Achternaam}
                            </div>
                          </td>
                          {this.state.Wedstrijd2.Speler2Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler2Set1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler2Set2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler2Set2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler2Set3Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler2Set3Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler2Set4Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler2Set4Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler2Set5Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd2.Speler2Set5Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd2.Speler2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieGold}>
                                {convertReeks(this.state.Wedstrijd2.Speler2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </Toolbar>
                </AppBar>
              </div>
            )}
          </div>
          <div>
            {this.state.Wedstrijd2.Speler1 === 'Wachten op' && (
              <AppBar position="static" color="default" style={{ backgroundColor: 'white' }}>
                <Toolbar style={{ justifyContent: 'center' }}>
                  <div style={{ color: 'blue', fontSize: 14 }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>{'Geen partij actief'}</span>
                  </div>
                </Toolbar>
              </AppBar>
            )}
          </div>

          <div>
            {this.state.Wedstrijd3.Speler1 !== 'Wachten op' && (
              <div style={{ marginBottom: 20 }}>
                <AppBar position="static" color="default" style={{ backgroundColor: 'white' }}>
                  <Toolbar style={{ justifyContent: 'flex-start' }}>
                    <table
                      //style={{width: 430px; height: 100px; margin-left: auto; margin-right: auto;}}
                      border="0"
                      cellspacing="0"
                      cellpadding="0"
                    >
                      <tbody>
                        <tr>
                          <td>Sets</td>
                          <td>&nbsp;</td>
                          <td
                            style={{
                              paddingLeft: 10
                            }}
                          >
                            Naam
                          </td>
                          {this.state.Wedstrijd3.Speler1Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieGray}>1</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Set2Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>2</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Set3Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>3</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Set4Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>4</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Set5Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>5</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Scoreverloop && (
                            <td style={{ color: 'blue' }}>
                              <TextLoop interval={2000}>{['Live', this.props.tafel === '1-4' ? 'T3' : 'T7']}</TextLoop>{' '}
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td style={styles.td}>
                            {this.state.Wedstrijd3.AantalsetsSpeler1 !== 0 ? (
                              <Avatar style={styles.avatarSerieBlack}>{this.state.Wedstrijd3.AantalsetsSpeler1}</Avatar>
                            ) : null}
                          </td>
                          <td style={styles.td}>
                            <Avatar rounded activeOpacity={1.0}>
                              <img src={this.state.Wedstrijd3.Speler1URL} style={{ width: 40 }} />
                            </Avatar>
                          </td>
                          <td style={styles.tdNaam}>
                            <div style={styles.Spelernaam}>
                              {this.state.Wedstrijd3.Speler1} {this.state.Wedstrijd3.Speler1Achternaam}
                            </div>
                          </td>
                          {this.state.Wedstrijd3.Speler1Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler1Set1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Set2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler1Set2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Set3Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler1Set3Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Set4Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler1Set4Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Set5Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler1Set5Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieBlack}>
                                {convertReeks(this.state.Wedstrijd3.Speler1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td style={styles.td}>
                            {this.state.Wedstrijd3.AantalsetsSpeler2 !== 0 ? (
                              <Avatar style={styles.avatarSerie}>{this.state.Wedstrijd3.AantalsetsSpeler2}</Avatar>
                            ) : null}
                          </td>
                          <td style={styles.td}>
                            <Avatar rounded activeOpacity={1.0}>
                              <img src={this.state.Wedstrijd3.Speler2URL} style={{ width: 40 }} />
                            </Avatar>
                          </td>
                          <td style={styles.tdNaam}>
                            <div style={styles.Spelernaam}>
                              {this.state.Wedstrijd3.Speler2} {this.state.Wedstrijd3.Speler2Achternaam}
                            </div>
                          </td>
                          {this.state.Wedstrijd3.Speler2Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler2Set1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler2Set2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler2Set2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler2Set3Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler2Set3Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler2Set4Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler2Set4Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler2Set5Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd3.Speler2Set5Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd3.Speler2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieGold}>
                                {convertReeks(this.state.Wedstrijd3.Speler2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </Toolbar>
                </AppBar>
              </div>
            )}
          </div>
          <div>
            {this.state.Wedstrijd3.Speler1 === 'Wachten op' && (
              <AppBar position="static" color="default" style={{ backgroundColor: 'white' }}>
                <Toolbar style={{ justifyContent: 'center' }}>
                  <div style={{ color: 'blue', fontSize: 14 }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>{'Geen partij actief'}</span>
                  </div>
                </Toolbar>
              </AppBar>
            )}
          </div>

          <div>
            {this.state.Wedstrijd4.Speler1 !== 'Wachten op' && (
              <div style={{ marginBottom: 20 }}>
                <AppBar position="static" color="default" style={{ backgroundColor: 'white' }}>
                  <Toolbar style={{ justifyContent: 'flex-start' }}>
                    <table
                      //style={{width: 430px; height: 100px; margin-left: auto; margin-right: auto;}}
                      border="0"
                      cellspacing="0"
                      cellpadding="0"
                    >
                      <tbody>
                        <tr>
                          <td>Sets</td>
                          <td>&nbsp;</td>
                          <td
                            style={{
                              paddingLeft: 10
                            }}
                          >
                            Naam
                          </td>
                          {this.state.Wedstrijd4.Speler1Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieGray}>1</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Set2Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>2</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Set3Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>3</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Set4Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>4</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Set5Scoreverloop && (
                            <td style={styles.td}>
                              {' '}
                              <Avatar style={styles.avatarSerieGray}>5</Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Scoreverloop && (
                            <td style={{ color: 'blue' }}>
                              <TextLoop interval={2000}>{['Live', this.props.tafel === '1-4' ? 'T4' : 'T8']}</TextLoop>{' '}
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td style={styles.td}>
                            {this.state.Wedstrijd4.AantalsetsSpeler1 !== 0 ? (
                              <Avatar style={styles.avatarSerieBlack}>{this.state.Wedstrijd4.AantalsetsSpeler1}</Avatar>
                            ) : null}
                          </td>
                          <td style={styles.td}>
                            <Avatar rounded activeOpacity={1.0}>
                              <img src={this.state.Wedstrijd4.Speler1URL} style={{ width: 40 }} />
                            </Avatar>
                          </td>
                          <td style={styles.tdNaam}>
                            <div style={styles.Spelernaam}>
                              {this.state.Wedstrijd4.Speler1} {this.state.Wedstrijd4.Speler1Achternaam}
                            </div>
                          </td>
                          {this.state.Wedstrijd4.Speler1Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler1Set1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Set2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler1Set2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Set3Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler1Set3Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Set4Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler1Set4Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Set5Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler1Set5Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieBlack}>
                                {convertReeks(this.state.Wedstrijd4.Speler1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                        </tr>
                        <tr>
                          <td style={styles.td}>
                            {this.state.Wedstrijd4.AantalsetsSpeler2 !== 0 ? (
                              <Avatar style={styles.avatarSerie}>{this.state.Wedstrijd4.AantalsetsSpeler2}</Avatar>
                            ) : null}
                          </td>
                          <td style={styles.td}>
                            <Avatar rounded activeOpacity={1.0}>
                              <img src={this.state.Wedstrijd4.Speler2URL} style={{ width: 40 }} />
                            </Avatar>
                          </td>
                          <td style={styles.tdNaam}>
                            <div style={styles.Spelernaam}>
                              {this.state.Wedstrijd4.Speler2} {this.state.Wedstrijd4.Speler2Achternaam}
                            </div>
                          </td>
                          {this.state.Wedstrijd4.Speler2Set1Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler2Set1Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler2Set2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler2Set2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler2Set3Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler2Set3Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler2Set4Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler2Set4Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler2Set5Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieScore}>
                                {convertReeks(this.state.Wedstrijd4.Speler2Set5Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                          {this.state.Wedstrijd4.Speler2Scoreverloop && (
                            <td style={styles.td}>
                              <Avatar style={styles.avatarSerieGold}>
                                {convertReeks(this.state.Wedstrijd4.Speler2Scoreverloop)}
                              </Avatar>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </Toolbar>
                </AppBar>
              </div>
            )}
          </div>
          <div>
            {this.state.Wedstrijd4.Speler1 === 'Wachten op' && (
              <AppBar position="static" color="default" style={{ backgroundColor: 'white' }}>
                <Toolbar style={{ justifyContent: 'center' }}>
                  <div style={{ color: 'blue', fontSize: 14 }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>{'Geen partij actief'}</span>
                  </div>
                </Toolbar>
              </AppBar>
            )}
          </div>

          {/* <Avatar
            avatarStyle={{
              height: 30,
              width: 30,
              borderRadius: 15,
              borderWidth: 1,
              borderColor: '#d4af37'
            }}
            rounded
            source={{ uri: this.state.Wedstrijd1.Speler1URL }}
            activeOpacity={1.0}
            containerStyle={{
              position: 'absolute',
              marginLeft: 140,
              marginTop: 240
            }}
          /> */}
          {/* Einde Tafel 1 */}
        </div>
      </div>
    );
  }
}
export default ScoreboardInvoertafels;
